import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/users'

const findOne = (userId, queryParams = '', organization) => AxiosClient.get(
  `${resource}/${userId}?${queryParams}`, { headers: { organization } }
)

export {
  findOne
}
